<ng-template #template>
  <div class="container">
    <div class="row px-0 py-5" style="min-height: 800px">
      <div class="p-lg-0 col-lg-12">
        <div class="card h-100">
          <div class="card-body table-responsive-md">
            <h3 style="margin-bottom: 0; margin-top: 15px">
              <span>{{ texts?.teamMembers }}</span>
            </h3>

            <div style="margin-top: 25px" *ngIf="members">
              <ul>
                <li *ngFor="let member of sortBy('firstName')">
                  <p>{{ member.firstName }} {{ member.lastName }}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
